module.exports = __webpack_public_path__ + "static/media/three_flying_dots.37d03f78.svg";